import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, animateOnMount = true }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(animateOnMount ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClass}`}
          variants={{ hidden: { y: "105%" }, show: { y: "0%" } }}
          transition={{ duration: 1.1, ease, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-flash ${className}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-flash" />
    {children}
  </p>
);
